import ContentTile from './ContentTile';

export { ContentTile };
